module.exports = __webpack_public_path__ + "img/zhi.2ba169ee.png";